import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { Observable, of } from 'rxjs';

import { LocalStorageService } from '@common/modules/shared/services/local-storage.service';
import { FeatureSwitchService } from '@common/modules/core/services/feature-switch/feature-switch.service';

import { BaseExtensionNavigationGuard } from './base-extension-navigation.guard';

export const MediaGalleryGuard: CanActivateFn = (): Observable<boolean> => {
  return inject(MediaGalleryGuardService).canActivate();
};

@Injectable({
  providedIn: 'root'
})
export class MediaGalleryGuardService extends BaseExtensionNavigationGuard {
  constructor(localStorageService: LocalStorageService, router: Router, store: Store, featureSwitchService: FeatureSwitchService) {
    super(localStorageService, router, store, featureSwitchService);
  }

  protected handleNoExtensionNavigation(): Observable<boolean> {
    return of(true);
  }
}
